<template>
  <div id="editLibraryLinkWrapper">
    <div class="field">
      <label class="label">Opschrift</label>

      <div class="control">
        <input
          class="input"
          name="caption"
          placeholder="Link tekst"
          :value="item.caption"
          @change="set('caption', $event.target.value)"
        >
      </div>
    </div>

    <div class="field">
      <label class="label">URL</label>

      <div class="control">
        <input
          class="input"
          name="url"
          placeholder="https://......"
          :value="item.url"
          @change="set('url', $event.target.value)"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditLibraryLink',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  methods: {
    set(key, value) {
      this.$store.commit('library/SET', { key, value })
    }
  }
}
</script>

<style scoped>

</style>
